import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
  durationMs: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly toasts = signal<ToastMessage[]>([]);

  show(message: string, type: ToastType = 'info', durationMs = 3500): number {
    const id = this.nextId++;
    const toast: ToastMessage = { id, message, type, durationMs };
    this.toasts.update((list) => [...list, toast]);

    if (durationMs > 0) {
      window.setTimeout(() => this.dismiss(id), durationMs);
    }

    return id;
  }

  success(message: string, durationMs = 3000): number {
    return this.show(message, 'success', durationMs);
  }

  error(message: string, durationMs = 4500): number {
    return this.show(message, 'error', durationMs);
  }

  info(message: string, durationMs = 3500): number {
    return this.show(message, 'info', durationMs);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }
}
